module.exports = __webpack_public_path__ + "img/kendra-circle.fa51a6a8.png";